import React, { FunctionComponent } from 'react';
import { SxProps, Theme } from '@mui/material';

import { PropertySelectField } from '@paragon/client-tools';
import { BevelCut } from '@paragon/contract-library';

import { DoubleBevelCutProperties } from './DoubleBevelCutProperties';
import { SingleBevelCutProperties } from './SingleBevelCutProperties';

interface Props {
  bevelCut: BevelCut | null;
  disabled: boolean;
  propertyName: string;
  readonly sx?: SxProps<Theme>;
  onEditBevelCut: (newBevelCut: BevelCut | null) => void;
}

type BevelCutType = 'None' | 'Front' | 'Back' | 'Double';
function getBevelCutType(bevelCut: BevelCut | null): BevelCutType {
  if (!bevelCut) return 'None';
  if (bevelCut.cutType === 'Double') return 'Double';
  return bevelCut.cutSide;
}

export const BevelCutProperties: FunctionComponent<Props> = (props: Props) => {
  const { bevelCut, disabled, propertyName, sx, onEditBevelCut } = props;

  const bevelCutTypes = ['None', 'Front', 'Back', 'Double'] as const;

  return (
    <>
      <PropertySelectField<BevelCutType>
        property={propertyName}
        value={getBevelCutType(bevelCut)}
        sx={sx}
        disabled={disabled}
        options={bevelCutTypes}
        submit={(value) => {
          onEditBevelCut(
            value === 'None'
              ? null
              : value === 'Double'
                ? { cutType: 'Double', frontAngle: 45, backAngle: 45 }
                : { cutType: 'Single', cutSide: value, angle: 45 },
          );
        }}
      />
      {bevelCut ? (
        bevelCut.cutType === 'Single' ? (
          <SingleBevelCutProperties bevelCut={bevelCut} disabled={disabled} onEditBevelCut={onEditBevelCut} />
        ) : (
          <DoubleBevelCutProperties bevelCut={bevelCut} disabled={disabled} onEditBevelCut={onEditBevelCut} />
        )
      ) : null}
    </>
  );
};
